import { NavLink } from "react-router-dom";
import "./PageNotFound.scss";

const PageNotFound = () => {
    return (
        <div className="PageNotFound">
            <div className="p-container">
                <div className="p-404">4</div>
                <div className="p-404">0</div>
                <div className="p-404">4</div>
            </div>
            <div className="p-message">¡Ups! Página no encontrada</div>
            <p className="p-description">
                Lo sentimos, la página que estás buscando no existe o ha sido
                movida.
            </p>
            <NavLink className="p-button" to="/">
                Volver al inicio
            </NavLink>
        </div>
    );
};

export default PageNotFound;
